export default () => ({
	differentDomains: true,
	legacy: false,
	useCookie: false
});
